module.exports = __webpack_public_path__ + "img/holzmann.c216d94d.png";